import React, { Component } from "react";
import {
	Row,
	Col,
	Select,
	Modal,
	InputNumber,
	Input,
	Switch,
	Upload,
	message,
	DatePicker,
	Button,
	Spin,
	Radio,
	Typography,
	Icon,
	Checkbox,
} from "antd";
import moment from "moment";
import axios from "axios";
import { connect } from "react-redux";
import {
	handleUpdate,
	deleteBanner,
	publishBanner,
	unpublishBanner,
	bannerPromoUpdation,
	bannerPromoDeletion,
	addBannerPromo,
} from "../../../actions/dealsHubAdmin";
import "./generic-banner.scss";
import "./generic-banner-listing-component.scss";
import isDev from "../../../server";
import EditorBox from "../../../components/EditorBox/EditorBox";
// import CustomEditor from "./CustomEditor";

const serverUrl = isDev();
const { RangePicker } = DatePicker;
const { Option } = Select;
const { Text } = Typography;

class PromoFlyer extends Component {
	rangePickerDateFormat = "YYYY-MM-DD HH:mm:ss";

	// rangePickerDateFormat = "DD/MM/YYYY HH:mm";

	constructor(props) {
		super(props);
		this.state = {
			spinnerLoading: false,
			isDeleteOn: false,
			promotionStartDate: null,
			promotionEndDate: null,
			promoUuid: "",
			promoTitle: "",
			promoType: "",
			type:"",
			isPromoPublished: false,
			promoDescription: "",
			promoStoreList: [],
			promoInnerImage: [],
			promoOuterImage: [],
			storeList: null,
			uploadingInProgress: false,
			previewVisible: false,
			previewImage: "",
			publishBannerBeforeAddition: false,
			innerImagesReadyToUpload: [],
			outerImagesReadyToUpload: [],
			isDeleteModalActive: false,
		};
	}

	componentDidMount = () => {
		this.setState(
			{
				spinnerLoading: true,
			},
			() => {
				axios
					.post(
						`${serverUrl}/${JSON.parse(localStorage.getItem("countryData")).database_identifier}/store/fetch-store-list-admin/`,
						{
							permission_category:["STORE_CONTROL_CENTER"]
						},
						{
							headers: {
								"Content-Type": "application/json",
								Authorization: `JWT ${localStorage.getItem("token")}`,
							},
						}
					)
					.then((response) => {
						if (response.data.status === 200 || response.status === 200) {
							this.setState(
								{
									promoUuid: this.props.bannerPromoData.uuid,
									promoTitle: this.props.bannerPromoData.title,
									promoType: 3,
									type:this.props.bannerPromoData.type,
									isPromoPublished: this.props.bannerPromoData.is_published,
									promoDescription: this.props.bannerPromoData.description,
									storeList: response.data.store_list,
									promoStoreList: this.props.bannerPromoData.stores,
									promoOuterImage: this.props.bannerPromoData.outer_image,
									// promoInnerImage: this.props.bannerPromoData.image_list,
									promoInnerImage: this.props.bannerPromoData.inner_image,
									promotionStartDate: this.props.bannerPromoData.start_time,
									promotionEndDate: this.props.bannerPromoData.end_time,
									// promotionStartDate: this.props.bannerPromoData.start_time ?
									//     this.props.bannerPromoData.start_time.replace(/\-/g, "/") :
									//     null,
									// promotionEndDate: this.props.bannerPromoData.end_time ?
									//     this.props.bannerPromoData.end_time.replace(/\-/g, "/") :
									//     null,
									spinnerLoading: false,
									isPromoBuffer: this.props.bannerPromoData.isBuffer || false,
								},
								() => {
								}
							);
						} else if (response.data.status === 403 || response.status === 403) {
							message.info("You are not authorised!");
						} else {
							message.error("Something went wrong while fetching Cohorts List!");
						}
					});
			}
		);
	};

	getFinalCohortsArray = () => {
		let temp = [];
		for (let item in this.state.storeList) {
			if (this.state.promoStoreList.includes(this.state.storeList[item].uuid)) {
				temp.push(this.state.storeList[item]);
			}
			// this.state.promoStoreList.map(pair => { return pair.uuid }),
		}
		this.setState({
			promoStoreList: temp,
			spinnerLoading: false,
		});
	};

	getPromoName = () => {
		this.props.promoTypes.map((item) => {
			if (item["key"] == this.state.promoType) {
				return item["value"];
			}
		});
	};

	changePromoTypeVariables = (finalVariableType, finalVariablevalue) =>
		this.setState(
			{
				[finalVariableType]: finalVariablevalue,
			},
			() => {
				this.props.updateNewDataInParent(this.getUpdatedPromoObj());
			}
		);

	getUpdatedPromoObj = () => {
		return {
			uuid: this.state.promoUuid,
			title: this.state.promoTitle,
			// promotion_type: this.state.promoType,
			// flyer_or_promotion: "flyer",
			type: "flyer",
			description: this.state.promoDescription,
			store_list: JSON.stringify(this.state.promoStoreList?.map(item=>item.uuid)),
			is_published: this.state.isPromoPublished,
			outer_image: this.state.promoOuterImage,
			inner_images: this.state.promoInnerImage,
			section_uuid: this.props.bannerPromoData.section_uuid,
			// "start_time": this.newFormatDate(this.state.promotionStartDate),
			// "end_time": this.newFormatDate(this.state.promotionEndDate),
			start_time: this.props.convertDateBeforeSending(this.state.promotionStartDate),
			end_time: this.props.convertDateBeforeSending(this.state.promotionEndDate),
			isBuffer: this.state.isPromoBuffer,
		};
	};

	getUpdatePromoObjFormData = () => {
		let formData = new FormData();
		formData.append("uuid", this.state.promoUuid);
		formData.append("title", this.state.promoTitle);
		// formData.append("promotion_type", this.state.promoType);
		formData.append("type", this.state.type);
		
		formData.append("description", this.state.promoDescription);
		formData.append("store_list", JSON.stringify(this.state.promoStoreList?.map(item=>item.uuid)));
		formData.append("section_uuid", this.props.bannerPromoData.section_uuid);
		// formData.append("start_time", this.newFormatDate(this.state.promotionStartDate))
		// formData.append("end_time", this.newFormatDate(this.state.promotionEndDate))
		if (this.state.promotionStartDate && this.state.promotionEndDate) {
			formData.append("start_time", this.props.convertDateBeforeSending(this.state.promotionStartDate));
			formData.append("end_time", this.props.convertDateBeforeSending(this.state.promotionEndDate));
		}
		formData.append("isBuffer", this.state.isPromoBuffer);
		return formData;
	};

	addPromo = () => {
		if (this.state.promoTitle === null || this.state.promoTitle === "") {
            message.error("Please enter Flyer Title ");
        } else if (this.state.promoDescription === null || this.state.promoDescription === "") {
            message.error("Please enter Flyer Description ");
        } else if (
            this.state.promoInnerImage === null ||
            this.state.promoInnerImage.length === 0
        ) {
            message.error("Please insert Flyer Outer Image");
        } else if (
            this.state.promotionStartDate === null ||
            this.state.promotionStartDate === "" ||
            this.state.promotionEndDate === null ||
            this.state.promotionEndDate === ""
        ) {
            message.error("Please insert Start and End Date");
        } else {if (this.state.isPromoBuffer) {
			this.props.setPromoBufferFalse();
		}
		this.setState(
			{
				spinnerLoading: true,
				isPromoBuffer: false,
			},
			() => {
				let formData = this.getUpdatePromoObjFormData();
				let bannerFlyerObj = this.getUpdatedPromoObj();

				formData.append("image_cnt", this.state.innerImagesReadyToUpload.length);

				for (let index = 0; index < this.state.innerImagesReadyToUpload.length; index++) {
					formData.append(`image_${index}`, this.state.innerImagesReadyToUpload[index].originFileObj);
				}

				if (this.state.outerImagesReadyToUpload.length == 0) formData.append("outer_image", []);
				else formData.append("outer_image", this.state.outerImagesReadyToUpload[0].originFileObj);
				formData.append("permission_category", JSON.stringify(["STORE_CONTROL_CENTER"]));
				axios
					.post(`${serverUrl}/${JSON.parse(localStorage.getItem("countryData")).database_identifier}/flyer/create-flyer/`, formData, {
						headers: {
							"Content-Type": "application/json",
							Authorization: `JWT ${localStorage.getItem("token")}`,
						},
					})
					.then((response) => {
						this.setState({
							innerImagesReadyToUpload: [],
						});
						if (response.status === 200 || response.status === 201) {
							message.success("Flyer Added Successfully!");
							bannerFlyerObj["uuid"] = response.data.uuid;
							if (response.data.outer_image) {
								bannerFlyerObj.outer_image = [
									{
										name: "flyer's outer image",
										status: "done",
										uid: response.data.outer_image.uuid,
										url: response.data.outer_image.url,
									},
								];
							}


							bannerFlyerObj.inner_image = [];
							response.data.inner_image_list.map((innerImage, index) => {
								bannerFlyerObj.inner_image.push({
									name: `flyer's inner image number ${index + 1}`,
									status: "done",
									uid: innerImage.uuid,
									url: innerImage.url,
								});
							});

							this.props.setPromoBufferFalse();
							this.props.addBannerPromo(bannerFlyerObj);
							this.props.updateNewDataInParent(bannerFlyerObj);
							
							this.setState(
								{
									spinnerLoading: false,
									promoUuid: response.data.uuid,
									promoOuterImage: bannerFlyerObj.outer_image,
									promoInnerImage: bannerFlyerObj.inner_image,
								},
								() => {
									this.state.publishBannerBeforeAddition &&
										this.setState(
											{
												publishBannerBeforeAddition: false,
											},
											() => {
												this.togglePublishBanner(!this.state.isPromoPublished);
											}
										);
								}
							);
							
							this.props.fetchInitialData();
							this.props.handleclosemodal();
						} else if (response.data.status === 403) {
							message.info("You are not authorised!");
						} else {
							message.error("Something went wrong!");
						}
					});
			}
		);}
	};

	newFormatDate = (dateString) => {
		if (dateString) {
			// let a = dateString.indexOf("Z");
			// let b = dateString.replace(/\//g, "-");
			// let n = [b.slice(0, a), ":00", b.slice(a)].join("");
			// return n;
			return dateString.replace(/\//g, "-");
		}
	};

	updatePromotionData = () => {
		if (this.state.promoTitle === null || this.state.promoTitle === "") {
            message.error("Please enter Flyer Title ");
        } else if (this.state.promoDescription === null || this.state.promoDescription === "") {
            message.error("Please enter Flyer Description ");
        } else if (
            this.state.promoOuterImage === null ||
            this.state.promoOuterImage.length === 0
        ) {
            message.error("Please upload Flyer Outer Image");
        } else if (
            this.state.promotionStartDate === null ||
            this.state.promotionStartDate === "" ||
            this.state.promotionEndDate === null ||
            this.state.promotionEndDate === ""
        ) {
            message.error("Please insert Start and End Date");
        } else{
			this.setState(
				{
					spinnerLoading: true,
				},
				() => {
					let finalPromoObj = this.getUpdatedPromoObj();
					axios
						.post(`${serverUrl}/${JSON.parse(localStorage.getItem("countryData")).database_identifier}/flyer/update-flyer/`, {...finalPromoObj,permission_category:["STORE_CONTROL_CENTER"]}, {
							headers: {
								"Content-Type": "application/json",
								Authorization: `JWT ${localStorage.getItem("token")}`,
							},
						})
						.then((response) => {
							if (response.data.status === 200) {
								message.success("Draft Saved Successfully!");
								this.props.bannerPromoUpdation({
									section_uuid: this.props.sectionUuid,
									promoObj: finalPromoObj,
								});
								this.props.updateNewDataInParent(finalPromoObj);
								this.setState({
									spinnerLoading: false,
								});
							} else if (response.data.status === 403) {
								message.info("You are not authorised!");
							} else {
								message.error("Something went wrong!");
							}
						});
				}
			);
		}
	};

	handleCancel = () => this.setState({ previewVisible: false });

	togglePublishBanner = (checked) => {
		this.setState(
			{
				spinnerLoading: true,
				isPromoPublished: checked,
			},
			() => {
				this.props.bannerPromoUpdation({
					section_uuid: this.props.sectionUuid,
					promoObj: {
						uuid: this.state.promoUuid,
					},
					isPublishToggled: checked,
				});
				axios
					.post(
						`${serverUrl}/${JSON.parse(localStorage.getItem("countryData")).database_identifier}/flyer/update-flyer/`,
						{
							uuid: this.state.promoUuid,
							is_published:checked,
							permission_category:["STORE_CONTROL_CENTER"]
						},
						{
							headers: {
								"Content-Type": "application/json",
								Authorization: `JWT ${localStorage.getItem("token")}`,
							},
						}
					)
					.then((response) => {
						if (response.data.status === 200 || response.status === 200) {
							message.success(`Flyer ${!checked ? "Unpublished" : "Published"} Successfully!`);
							this.setState({ spinnerLoading: false });
						} else if (response.data.status === 403 || response.status === 403) {
							message.info("You are not authorised!");
						} else {
							message.error("Something went wrong while fetching Cohorts List!");
						}
					});
			}
		);
	};

	updateName = (newName) =>
		this.setState(
			{
				promoTitle: newName,
			},
			() => {
				this.props.updateNewDataInParent(this.getUpdatedPromoObj());
			}
		);

	updateStoreList = (selectedCohortsArray) =>
		this.setState(
			{
				promoStoreList: selectedCohortsArray,
			},
			() => {
				this.props.updateNewDataInParent(this.getUpdatedPromoObj());
			}
		);

	changeTime = (str, time) => {
		let tempArr = str.split(" ");
		tempArr[1] = time;
		return tempArr.join(" ");
	};

	changePromotionRange = (dateRangeMoment, dateRangeStrings) => {
		dateRangeStrings[0] = moment(dateRangeStrings[0], "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
		dateRangeStrings[1] = moment(dateRangeStrings[1], "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");

		this.setState(
			{
				promotionStartDate: dateRangeStrings[0] === "" ? null : dateRangeStrings[0].replace(" ", "T").concat("Z"),
				promotionEndDate: dateRangeStrings[1] === "" ? null : dateRangeStrings[1].replace(" ", "T").concat("Z"),
			},
			() => {
				this.props.updateNewDataInParent(this.getUpdatedPromoObj());
			}
		);
	};

	getBase64 = (img, callback) => {
		const reader = new FileReader();
		reader.addEventListener("load", () => callback(reader.result));
		reader.readAsDataURL(img);
	};

	getEditorText = (e) => {
		this.setState({
			promoDescription: e,
		});
	};

	beforeInnerImageUpload = (file) => {
		const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
		if (!isJpgOrPng) {
			message.error("You can only upload JPG/PNG file!");
		}
		const isLt2M = file.size / 1024 / 1024 < 2;
		if (!isLt2M) {
			message.error("Image must smaller than 2MB!");
		}
		return isJpgOrPng && isLt2M;
	};

	imageUploadTimeOut;

	handleInnerImageChangeAtCreate = ({ fileList }) => {
		if (fileList.length > 0 && !this.state.uploadingInProgress && !this.state.isDeleteOn) {
			this.setState({
				promoInnerImage: fileList,
				innerImagesReadyToUpload: fileList,
			});
		}
	};

	uploadImages = () => {
		clearTimeout(this.imageUploadTimeOut);
		let formData = new FormData();
		formData.append("image_cnt", this.state.innerImagesReadyToUpload.length);
		for (let index = 0; index < this.state.innerImagesReadyToUpload.length; index++) {
			formData.append(`image_${index}`, this.state.innerImagesReadyToUpload[index].originFileObj);
		}
		formData.append("uuid", this.state.promoUuid);
		formData.append("permission_category", JSON.stringify(["STORE_CONTROL_CENTER"]));
		formData.append("flyer_uuid", this.state.promoUuid);
		if (!this.state.isPromoBuffer) {
			axios
				.post(`${serverUrl}/${JSON.parse(localStorage.getItem("countryData")).database_identifier}/flyer/upload-flyer-images/`, formData, {
					headers: {
						"Content-Type": "multipart/form-data",
						Authorization: `JWT ${localStorage.getItem("token")}`,
					},
				})
				.then((response) => {
					let temp = [];
					response.data.image_list.map((imageObj, index) => {
						temp.push({
							name: `flyer's inner image number ${index}`,
							status: "done",
							uid: imageObj.uuid,
							url: imageObj.url,
						});
					});
					this.setState(
						{
							uploadingInProgress: false,
							spinnerLoading: false,
							isDeleteOn: false,
							promoInnerImage: [...this.state.promoInnerImage, ...temp],
							innerImagesReadyToUpload: [],
						},
						() => {
							this.props.bannerPromoUpdation({
								section_uuid: this.props.sectionUuid,
								promoObj: this.getUpdatedPromoObj(),
							});
							message.success("Promo Outer Image Uploaded Successfully!");
						}
					);
				});
		} else {
			this.setState({
				uploadingInProgress: false,
				spinnerLoading: false,
				isDeleteOn: false,
				promoInnerImage: [...this.state.innerImagesReadyToUpload],
			});
		}
	};

	handleInnerImageChange = ({ file, fileList }) => {
		if (
			fileList.length > 0 &&
			// !this.state.uploadingInProgress &&
			!this.state.isDeleteOn
		) {
			this.setState({
				uploadingInProgress: true,
			});
			clearTimeout(this.imageUploadTimeOut);

			let innerImagesReadyToUpload_Copy = this.state.innerImagesReadyToUpload;
			innerImagesReadyToUpload_Copy.push(file);
			this.setState({
				innerImagesReadyToUpload: [...innerImagesReadyToUpload_Copy],
			});

			this.imageUploadTimeOut = setTimeout(() => {
				this.uploadImages();
			}, 1000);
		}
	};

	handleOuterImageChangeAtCreate = ({ fileList }) => {
		if (fileList.length > 0 && !this.state.uploadingInProgress && !this.state.isDeleteOn) {
			this.setState({
				promoOuterImage: fileList,
				outerImagesReadyToUpload: fileList,
			});
		}
	};

	imageUploadTimeOutOuter;

	uploadImagesOuter = () => {
		clearTimeout(this.imageUploadTimeOutOuter);
		let formData = new FormData();
		for (let index = 0; index < this.state.outerImagesReadyToUpload.length; index++) {
			formData.append(`outer_image`, this.state.outerImagesReadyToUpload[0].originFileObj);
		}
		formData.append("uuid", this.state.promoUuid);
		formData.append("permission_category", JSON.stringify(["STORE_CONTROL_CENTER"]));

		if (!this.state.isPromoBuffer) {
			axios
				.post(`${serverUrl}/${JSON.parse(localStorage.getItem("countryData")).database_identifier}/flyer/upload-flyer-outer-image/`, formData, {
					headers: {
						"Content-Type": "multipart/form-data",
						Authorization: `JWT ${localStorage.getItem("token")}`,
					},
				})
				.then((response) => {
					this.setState(
						{
							uploadingInProgress: false,
							spinnerLoading: false,
							isDeleteOn: false,
							promoOuterImage: [
								{
									name: `${this.props.bannerPromoData.title}'s outer image`,
									status: "done",
									uid: response.data.uuid,
									url: response.data.url,
								},
							],
							outerImagesReadyToUpload: [],
						},
						() => {
							this.props.bannerPromoUpdation({
								section_uuid: this.props.sectionUuid,
								promoObj: this.getUpdatedPromoObj(),
							});
							message.success("Promo Outer Image Uploaded Successfully!");
						}
					);
				});
		} else {
			this.setState({
				uploadingInProgress: false,
				spinnerLoading: false,
				isDeleteOn: false,
				promoOuterImage: this.state.outerImagesReadyToUpload,
			});
		}
	};

	handleOuterImageChange = ({ file, fileList }) => {
		if (fileList.length > 0 && !this.state.uploadingInProgress && !this.state.isDeleteOn) {
			this.setState({
				uploadingInProgress: true,
			});
			clearTimeout(this.imageUploadTimeOut);

			let outerImagesReadyToUpload_Copy = this.state.outerImagesReadyToUpload;
			outerImagesReadyToUpload_Copy.push(file);
			this.setState({
				outerImagesReadyToUpload: [...outerImagesReadyToUpload_Copy],
			});

			this.imageUploadTimeOut = setTimeout(() => {
				this.uploadImagesOuter();
			}, 1000);
		}
	};

	removeOuterImageFile = (file) => {
		this.setState(
			{
				isDeleteOn: true,
				spinnerLoading: true,
			},
			() => {
				if (!this.state.isPromoBuffer) {
					axios
						.post(
							`${serverUrl}/${JSON.parse(localStorage.getItem("countryData")).database_identifier}/flyer/remove-flyer-image/`,
							{
								uuid: this.state.promoOuterImage[0].uid,
								permission_category:["STORE_CONTROL_CENTER"]
							},
							{
								headers: {
									"Content-Type": "application/json",
									Authorization: `JWT ${localStorage.getItem("token")}`,
								},
							}
						)
						.then((response) => {
							if (response.data.status === 200) {
								this.setState(
									{
										spinnerLoading: false,
										isDeleteOn: false,
										promoOuterImage: [],
									},
									() => {
										this.props.bannerPromoUpdation({
											section_uuid: this.props.sectionUuid,
											promoObj: this.getUpdatedPromoObj(),
										});
									}
								);
								message.success("Promo Image Deleted Successfully!");
							} else if (response.data.status === 405) {
								message.info("You are not authorised!");
							} else {
								message.error("Something went Wrong!");
							}
						});
				} else {
					this.setState(
						{
							spinnerLoading: false,
							isDeleteOn: false,
							promoOuterImage: [],
						},
						() => {
						}
					);
				}
			}
		);
	};

	dummyInnerImageRequest = ({ file, onSuccess }) => {
		setTimeout(() => {
			onSuccess("ok");
		}, 0);
	};

	handleInnerImagePreview = async (file) => {
		if (!file.url && !file.preview) {
			file.preview = await this.getBase64(file.originFileObj);
		}
		this.setState({
			previewImage: file.url || file.preview,
			previewVisible: true,
		});
	};

	removeInnerImageFile = (file) => {
		let tempImagesList = this.state.promoInnerImage;

		for (let index in this.state.promoInnerImage) {
			if (tempImagesList[index].uid == file.uid) {
				tempImagesList.splice(index, 1);
				break;
			}
		}

		this.setState(
			{
				isDeleteOn: true,
				spinnerLoading: true,
			},
			() => {
				if (!this.state.isPromoBuffer) {
					axios
						.post(
							`${serverUrl}/${JSON.parse(localStorage.getItem("countryData")).database_identifier}/flyer/remove-flyer-image/`,
							{
								uuid: file.uid,
								permission_category:["STORE_CONTROL_CENTER"]
							},
							{
								headers: {
									"Content-Type": "application/json",
									Authorization: `JWT ${localStorage.getItem("token")}`,
								},
							}
						)
						.then((response) => {
							if (response.data.status === 200) {
								this.setState(
									{
										spinnerLoading: false,
										isDeleteOn: false,
										promoInnerImage: tempImagesList,
									},
									() => {
										this.props.bannerPromoUpdation({
											section_uuid: this.props.sectionUuid,
											promoObj: this.getUpdatedPromoObj(),
										});
									}
								);
								message.success("Promo Image Deleted Successfully!");
							} else if (response.data.status === 405) {
								message.info("You are not authorised!");
							} else {
								message.error("Something went Wrong!");
							}
						});
				} else {
					this.setState(
						{
							spinnerLoading: false,
							isDeleteOn: false,
							promoInnerImage: tempImagesList,
						},
						() => {
						}
					);
				}
			}
		);
	};

	openDeleteModal = () => this.setState({ isDeleteModalActive: true });

	closeDeleteModal = () => this.setState({ isDeleteModalActive: false });

	render() {
		if (!this.state.spinnerLoading) {
			return (
				<Row className="modal-row">
					<Row align={"middle"} type={"flex"} justify={"space-between"}>
						<Text
							style={{
								fontWeight: "bold",
								color: "#181818",
								fontSize: "24px",
							}}>
							<img
								src={this.props.flyerlogo}
								style={{
									height: "40px",
									width: "54px",
									borderRadius: "5px",
									marginRight: "16px",
								}}
							/>

							{!this.state.isPromoBuffer ? "View " : "Create "}
							{this.props.promoName}
						</Text>

						<div onClick={(e) => e.stopPropagation()}>
							<Col style={{ borderRight: "1px solid #E8E8E8", marginRight: "48px", marginTop: "-5px" }}>
								<Switch
									defaultChecked={this.props.bannerPromoData.is_published}
									checked={this.state.isPromoPublished}
									onChange={(checked) => {
										this.setState(
											{
												publishBannerBeforeAddition: true,
											},
											() => {
												if (this.state.isPromoBuffer && this.state.publishBannerBeforeAddition) {
													this.addPromo();
												} else {
													this.togglePublishBanner(checked);
												}
											}
										);
									}}
									style={{ marginRight: "30px" }}
								/>
							</Col>
						</div>
					</Row>
					<Row
						style={{
							marginTop: "30px",
						}}>
						<Col
							span={13}
							style={{
								marginRight: "20px",
								borderRadius: "10px",
								border: "1px solid #E8E8E8",
							}}>
							<Col
								span={24}
								style={{
									padding: "20px",
									borderBottom: "1px solid #E8E8E8",
								}}>
								<Col span={24}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",
										}}>
										Promotion Title <span style={{color:"red"}}>*</span>
									</Text>
									<Input
										style={{
											backgroundColor: "#FFFFFF",
											border: "1px solid #D9D9D9",
											borderRadius: "2px",
											marginTop: "8px",
										}}
										placeholder={"Eg. - Mid Week deals"}
										defaultValue={this.props.bannerPromoData.title}
										value={this.state.promoTitle}
										onChange={(e) => {
											this.updateName(e.target.value);
										}}
										maxLength={100}
									/>
								</Col>
								<Col
									span={24}
									style={{
										marginBottom: "44px",
										marginTop: "24px",
									}}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",
										}}>
										Promotion Description <span style={{color:"red"}}>*</span>
									</Text>
									<EditorBox
										GenericBannerModal={true}
										height="200px"
										value={this.state.promoDescription}
										getText={this.getEditorText}
										style={{ borderRadius: "5px" }}
									/>
								</Col>
							</Col>
							<Col
								span={24}
								style={{
									padding: "20px",
									// borderBottom: '1px solid #E8E8E8'
								}}>
								<Row className="image-upload-row">
									<React.Fragment>
										<Col span={24} className="image-upload-col" style={{ padding: 0 }}>
											<Text
												style={{
													fontSize: "14px",
													color: "#181818",
													fontWeight: "bold",
												}}>
												Outer Image <span style={{color:"red"}}>*</span>
											</Text>
											<br />
											<Text style={{ fontSize: "12px" }}>Allowed image format is JPG, JPEG, PNG and size 180x140 upto 20KB - 40KB</Text>
											<div
												style={{
													//borderRadius: '10px',
													border: `${this.state.promoOuterImage.length > 0 ? "none" : "1px dashed #C4C4C4"}`,
												}}
												className="image-upload-container">
												<Upload
													showUploadList={{ showPreviewIcon: false }}
													listType="picture-card"
													// showUploadList={false}
													style={{
														height: "150px",
													}}
													beforeUpload={this.beforeInnerImageUpload}
													//call handleOuterImageChangeAtCreate at create time otherwise handleOuterImageChange
													onChange={this.state.isPromoBuffer ? this.handleOuterImageChangeAtCreate : this.handleOuterImageChange}
													onPreview={this.handleInnerImagePreview}
													onRemove={this.removeOuterImageFile}
													customRequest={this.dummyInnerImageRequest}
													fileList={this.state.promoOuterImage}>
													{this.state.promoOuterImage.length > 0 ? null : (
														<>
															<p className="ant-upload-drag-icon" style={{ marginTop: "30px" }}>
																<Icon type="cloud-upload" style={{ fontSize: "24px" }} />
															</p>
															<p className="ant-upload-text">Drag and drop or upload Images</p>
														</>
													)}
												</Upload>
											</div>
										</Col>
										<Col span={24} className="image-upload-col" style={{ padding: 0 }}>
											<Col span={24} style={{ marginTop: "18px" }}>
												{" "}
											</Col>
											<Text
												style={{
													fontSize: "14px",
													color: "#181818",
													fontWeight: "bold",
													marginTop: "24px",
												}}>
												Inner Images
											</Text>
											<br />
											<Text style={{ fontSize: "12px" }}>Allowed image format is JPG, JPEG, PNG and size 280x140 upto 20KB - 40KB</Text>
											<div
												style={{
													// borderRadius: '10px',
													border: `${this.state.promoInnerImage.length > 0 ? "none" : "1px dashed #C4C4C4"}`,
												}}
												className="image-upload-container">
												<Upload
													showUploadList={{ showPreviewIcon: false }}
													listType="picture-card"
													// showUploadList={false}
													style={{
														height: "150px",
													}}
													beforeUpload={this.beforeInnerImageUpload}
													// onChange={this.handleInnerImageChange}
													// at Create time call handleInnerImageChangeAtCreate otherwise call handleInnerImageChange
													// onChange={this.handleInnerImageChangeAtCreate}
													onChange={this.state.isPromoBuffer ? this.handleInnerImageChangeAtCreate : this.handleInnerImageChange}
													onPreview={this.handleInnerImagePreview}
													onRemove={this.removeInnerImageFile}
													customRequest={this.dummyInnerImageRequest}
													fileList={this.state.promoInnerImage}
													multiple={true}>
													{this.state.promoInnerImage.length > 100 ? null : (
														<>
															<p className="ant-upload-drag-icon" style={{ marginTop: "30px" }}>
																<Icon type="cloud-upload" style={{ fontSize: "24px" }} />
															</p>
															<p className="ant-upload-text">Drag and drop or upload Images</p>
														</>
													)}
												</Upload>
											</div>
										</Col>
									</React.Fragment>
								</Row>
							</Col>
						</Col>
						<Col
							span={10}
							style={{
								minHeight: "930px",
								borderRadius: "10px",
								border: "1px solid #E8E8E8",
							}}>
							<Col
								span={24}
								style={{
									padding: "20px",
									borderBottom: "1px solid #E8E8E8",
								}}>
								<Col span={24}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",
										}}>
										Start - End Date <span style={{color:"red"}}>*</span>
									</Text>
									<br />
									<RangePicker
										className="time-value-cohort-col-main-element"
										defaultValue={
											this.state.promotionStartDate && this.rangePickerDateFormat
												? [
													moment(this.state.promotionStartDate, this.rangePickerDateFormat),
													moment(this.state.promotionEndDate, this.rangePickerDateFormat),
												  ]
												: null
										}
										showTime={{ format: "HH:mm:ss" }}
										format={"DD-MM-YYYY HH:mm:ss"}
										placeholder={["Start Time", "End Time"]}
										onOk={() => {}}
										onChange={this.changePromotionRange}
									/>
								</Col>
							</Col>
							<Col
								span={24}
								style={{
									padding: "20px",
									// borderBottom: '1px solid #E8E8E8'
								}}>
								<Row>
									<Col span={24}>
										<Text
											style={{
												fontSize: "14px",
												color: "#181818",
												fontWeight: "bold",
											}}>
											Add Store Location for the Flyer
										</Text>
										<Select
											mode="multiple"
											style={{ width: "100%" }}
											placeholder="Select Location(s)"
											optionFilterProp="children"
											filterOption={(input, option) => option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}
											className="time-value-cohort-col-main-element dont-show"
											defaultValue={this.state.promoStoreList?.map((item) => {
												for (let i = 0; i < this.state.storeList.length; i++) {
													if (this.state.storeList[i].uuid === item.uuid) {
														return item.uuid;
													}
												}
											})}
											onChange={(e) => {
												let storeList = e.map((label_uuid) => {
													let uuid = label_uuid;
													for (let i = 0; i < this.state.storeList.length; i++) {
														if (this.state.storeList[i].uuid === uuid) return this.state.storeList[i];
													}
												});
												this.updateStoreList(storeList);
											}}>
											{this.state.storeList &&
												this.state.storeList
													.filter((store) => store.is_enabled)
													?.map((storeItem) => {
														return (
															<Option
																className={"dont-show"}
																value={storeItem.uuid}
																key={storeItem.uuid}
																label={`${storeItem.name} | ${storeItem.location.address} | ${storeItem.location.region}`}>
																<div style={{ width: "100%" }}>
																	<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "14px", lineHeight: "22px", color: "#181818" }}>
																		{storeItem.name}
																	</Text>
																	<br />
																	<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "12px", lineHeight: "18px" }}>
																		{storeItem.location.address}, {storeItem.location.region}
																	</Text>
																</div>
															</Option>
														);
													})}
										</Select>
									</Col>
								</Row>
							</Col>
						</Col>
					</Row>
					{!this.state.isPromoBuffer ? (
						<Col
							span={24}
							style={{
								marginTop: "40px",
								display: "flex",
								justifyContent: "space-between",
							}}>
							<Button
								onClick={this.openDeleteModal}
								style={{
									width: "78px",
									height: "40px",
									borderRadius: "2px",
									border: "1px solid #F5222D",
									backgroundColor: "#FFFFFF",
									color: "#F5222D",
								}}>
								Delete
							</Button>
							<Button
								onClick={() => {
									this.updatePromotionData();
								}}
								style={{
									width: "150px",
									height: "40px",
									borderRadius: "2px",
									border: "none",
									backgroundColor: "#fec708",
									color: "#FFFFFF",
								}}>
								Save & Update
							</Button>
						</Col>
					) : (
						<Col span={24} style={{ textAlign: "right", marginTop: "40px" }}>
							<Button
								//disabled={!(this.state.promoType !== "" && this.state.promoTitle !== "" && this.state.promoDescription !== "" && this.state.promotionStartDate != null && this.state.promoOuterImage.length > 0 && this.state.promoInnerImage.length > 0)}
								onClick={() => {
									this.state.isPromoBuffer ? this.addPromo() : this.updatePromotionData();
									// this.addPromo();
								}}
								style={{
									width: "106px",
									height: "40px",
									borderRadius: "2px",
									color: "#1890FF",
									border: "1px solid #1890FF",
									marginRight: "16px",
								}}>
								Save Draft
							</Button>
							<Button
								//disabled={!(this.state.promoType !== "" && this.state.promoTitle !== "" && this.state.promoDescription !== "" && this.state.promotionStartDate != null && this.state.promoOuterImage.length > 0 && this.state.promoInnerImage.length > 0)}
								onClick={() => {
									this.setState(
										{
											publishBannerBeforeAddition: true,
										},
										() => {
											this.addPromo();
										}
									);
								}}
								style={{
									width: "150px",
									height: "40px",
									borderRadius: "2px",
									border: "none",
									backgroundColor: "#fec708",
									color: "#FFFFFF",
									// backgroundColor: this.state.promoType !== "" && this.state.promoTitle !== "" && this.state.promoDescription !== "" && this.state.promotionStartDate != null && this.state.promoOuterImage.length > 0 && this.state.promoInnerImage.length > 0 ? '#fec708' : '#E8E8E8',
									//color: this.state.promoType !== "" && this.state.promoTitle !== "" && this.state.promoDescription !== "" && this.state.promotionStartDate != null && this.state.promoOuterImage.length > 0 && this.state.promoInnerImage.length > 0 ? '#FFFFFF' : '#747474'
								}}>
								Publish
							</Button>
						</Col>
					)}
					<Modal
						visible={this.state.isDeleteModalActive}
						footer={null}
						onCancel={this.closeDeleteModal}
						destroyOnClose={true}
						maskClosable={false}
						style={{
							backgroundColor: "#fff",
							borderRadius: "10px",
							boxShadow: "0px 10px 30px rgba(24, 24, 24, 0.2)",
						}}
						bodyStyle={{
							background: "#fff",
							borderRadius: "10px",
						}}
						title={null}>
						<Row className="modal-row">
							<Row>
								<Icon
									type="delete"
									style={{
										color: "#181818",
										fontSize: "24px",
										marginRight: "16px",
									}}
								/>
								<Text
									style={{
										fontWeight: "bold",
										color: "#181818",
										fontSize: "24px",
									}}>
									Delete item
								</Text>
							</Row>
							<Row style={{ marginTop: "24px" }}>
								<Col span={24}>
									<Text>Are you sure you want to delete this Flyer?</Text>
								</Col>
								<Col
									style={{
										marginTop: "60px",
										textAlign: "right",
									}}
									span={18}>
									<Button
										style={{
											height: "40px",
											boxShadow: "none",
											borderRadius: "20px",
											border: "none",
											backgroundColor: "#FFFFFF",
											color: "#181818",
										}}
										onClick={this.closeDeleteModal}>
										Cancel
									</Button>
								</Col>
								<Col
									style={{
										marginTop: "60px",
										textAlign: "right",
									}}
									span={6}>
									<Button
										style={{
											height: "40px",
											borderRadius: "2px",
											border: "none",
											backgroundColor: "#C91713",
											color: "#FFFFFF",
										}}
										onClick={() => {
											this.closeDeleteModal();
											this.props.closeFlyerPromoModal(this.getUpdatedPromoObj());
										}}>
										Delete
									</Button>
								</Col>
							</Row>
						</Row>
					</Modal>
				</Row>
			);
		} else {
			return <Spin></Spin>;
		}
	}
}

const mapStateToProps = ({ dealsHubAdmin }) => {
	return {
		dealsHubAdmin,
	};
};

export default connect(mapStateToProps, {
	handleUpdate,
	deleteBanner,
	publishBanner,
	unpublishBanner,
	bannerPromoUpdation,
	bannerPromoDeletion,
	addBannerPromo,
})(PromoFlyer);
